import { render, staticRenderFns } from "./clientOrder.vue?vue&type=template&id=6d60f5a0"
import script from "./clientOrder.vue?vue&type=script&lang=js"
export * from "./clientOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports